import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import StudentTable from "./Component/StudentTable"
import "./student.css"

const Student =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <StudentTable />
        </div>
        <Footer />
        </>
    )
}

export default Student